import { render, staticRenderFns } from "./CustomersHistory.vue?vue&type=template&id=1aa80663&"
import script from "./CustomersHistory.vue?vue&type=script&lang=js&"
export * from "./CustomersHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports